import * as React from "react";
import * as style from "./backToTop.module.scss";
import { useState, useEffect } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import Link from "components/Link";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

const BackToTop = () => {
  const { t } = useTranslation();
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const updatePosition = () => {
      setScrollPosition(window.pageYOffset);
    };
    window.addEventListener("scroll", updatePosition);
    return () => window.removeEventListener("scroll", updatePosition);
  }, []);
  const heightTrigger = 5000;
  const scrollToTop = event => {
    event.preventDefault();
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      window.scrollTo(0, 0);
      return;
    }

    const startY = window.scrollY;
    const startTime = window.performance.now();
    const duration = 450;
    const animate = now => {
      const progress = Math.min((now - startTime) / duration, 1);
      window.scrollTo(0, startY * (1 - progress) ** 3);
      if (progress < 1) window.requestAnimationFrame(animate);
    };
    window.requestAnimationFrame(animate);
  };

  return (
    <>
      {scrollPosition > heightTrigger && (
        <Link
          to="#"
          className={style.BackToTop}
          onClick={scrollToTop}
        >
          <span>{t("backToTop")}</span>
          <ArrowUpwardIcon />
        </Link>
      )}
    </>
  );
};

export default BackToTop;
